// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";

const namespaces = ["common", "routes", "agentManagement", "auth"];

i18n
  // 使用 http-backend 插件，它能讓我們從遠端載入翻譯檔
  .use(HttpApi)
  // 將 i18n 實例傳遞給 react-i18next
  .use(initReactI18next)
  // 初始化 i18next
  .init({
    fallbackLng: "en",
    // include legacy "zh" to avoid missing translations from old persisted lang codes
    supportedLngs: ["en", "es", "pt", "zh-TW", "zh"],
    ns: namespaces,
    defaultNS: "common",
    fallbackNS: "common",
    debug: process.env.NODE_ENV === "development",
    backend: {
      loadPath: `${process.env.PUBLIC_URL || ""}/locales/{{lng}}/{{ns}}.json`,
    },

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
